/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Season_Mid_Season_Text_CtaInputs */



/**
* | output |
* | --- |
* | "Ventilation units remain in winter mode" |
*
* @param {Season_Mid_Season_Text_CtaInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const season_mid_season_text_cta = /** @type {((inputs?: Season_Mid_Season_Text_CtaInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Season_Mid_Season_Text_CtaInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Ventilation units remain in winter mode")
	return /** @type {LocalizedString} */ ("Les équipements de ventilation restent en mode hiver")
});